module.exports = __webpack_public_path__ + "img/coursetype-WBT.23b028ce.png";